<template>
  <div id="viewIdle11" style="padding-bottom:60px" v-if="data" class="container">
    <div class="viewIdle_box">
      <div class="box" v-if="data">
        <el-row>
          <el-col :span="8">
            <el-image
              style="width:350px;height:350px"
              class="cover"
              :src="data.info.image"
              fit="cover"
            ></el-image>
          </el-col>
          <el-col :span="12">
            <div class="t1 lv1Text">{{data.info.title}}</div>

            <div class="b2 lv3Text">
              <div class="t2">
                <span>价 格 :</span>
                <strong style="font-size:24px;color:#E2211C;font-weight:700">&yen;{{123123123}}</strong>
              </div>
              <div class="t2">
                <span>品 牌 :</span>
                <strong>{{data.info.brand}}</strong>
                <span style="margin-left:59px">规 格:</span>
                <strong>{{data.info.specification}}</strong>
              </div>
              <div>
                <span>货 号 :</span>
                <strong>{{data.info.item_no}}</strong>
              </div>
              <div>
                <span>发起人 :</span>
                <strong>{{data.info.publish_member}}</strong>
              </div>
              <div>
                <span>联系电话 :</span>
                <strong>{{data.info.link_phone}}</strong>
              </div>
            </div>
            <div class="d1 clearfix">
              <div class="idleHome_right_seach_ipt">{{'https://www.bioflin.com/#' + $route.fullPath}}</div>

              <el-button
                type="info"
                v-clipboard:copy="'https://www.bioflin.com/#' + $route.fullPath"
                v-clipboard:success="onCopy"
                style="border-radius: 0;background:#4F9CDC;border-color:#4F9CDC"
              >复制链接</el-button>
            </div>
            <div class="btn">
              <el-button
                style="width:150px;height:48px"
                @click="ping"
                v-if="data.info.surplus > 0"
                type="primary"
              >拼大包装</el-button>
              <el-button style="width:150px;height:48px" type="info" v-else>大包装已拼完</el-button>
            </div>
          </el-col>
          <el-col :span="4">
            <div style="margin: 60px  20px">
              <div style="border:1px solid rgba(221, 221, 221, 1);">
                <qrcode-vue
                  style="padding:5px 5px"
                  :value="'https://www.bioflin.com/#'+ $route.fullPath"
                  :size="140"
                  level="H"
                ></qrcode-vue>
              </div>
              <div style="text-align:center;padding-top:10px">扫码分享商品</div>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="box2">
        <el-row :gutter="12">
          <el-col :span="19">
            <div class="col">
              <div class="detale">
                <div>商品详情</div>
              </div>
              <div class="info">
                <div class="info_top">
                  <p>提示 ：</p>
                  <p>需拼单总数量：{{data.info.number}}{{data.info.unit}}(注释最小单位)；</p>
                  <p
                    v-for="item in data.buyerList"
                    :key="item.id"
                  >{{item.buyer_name}} 电话：{{item.link_phone}}，单位：{{item.company_name}}，购买{{item.number}}{{data.info.unit}}；</p>
                  <p>剩余数量：{{data.info.surplus}}{{data.info.unit}}；</p>
                </div>
                <div class="info_info">
                  <h3>商品详情</h3>
                  <div v-html="data.info.html_info"></div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="share_right">
              <div class="share_right_tit">
                <div></div>看了又看
                <div></div>
              </div>
              <div
                align="center"
                style="background:#fff;padding-bottom:10px"
                v-for="(item,index) of top4"
                :key="index"
                class="share_right_list"
              >
                <router-link :to="'/group_details?id=' + item.id">
                  <el-image
                    class="cover2"
                    style="width: 160px; height: 160px;padding-top:20px;"
                    :src="item.image"
                    fit="cover"
                  ></el-image>
                </router-link>
                <div class="lv1Text d2">
                  <router-link :to="'share_details?id='+item.id">{{item.title}}</router-link>
                </div>
                <div style="font-size:14px;font-weight:400;color:rgba(226,33,28,1);">&yen;123</div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog title="拼大包装" :visible.sync="dialogFormVisible" width="490px" center>
      <el-form :model="user_info">
        <el-form-item label="购买人：" label-width="100px">
          <el-input
            v-model="user_info.nickname"
            placeholder="请输入购买人"
            style="width:280px"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="单位：" label-width="100px">
          <el-input
            style="width:280px"
            autocomplete="off"
            v-model="user_info.organization"
            placeholder="请输入单位"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话：" label-width="100px">
          <el-input
            v-model="user_info.bind_mobile"
            style="width:280px"
            autocomplete="off"
            placeholder="请输入联系电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="购买数量：" label-width="100px">
          <el-alert
            style="width:280px;height:30px;margin-top:-10px"
            v-if="error_show"
            title="购买数量不可大于剩余数量"
            type="error"
          ></el-alert>
          <el-input
            @input="change_number_ipt"
            v-model="user_info.number"
            style="width:280px"
            autocomplete="off"
            placeholder="请输入购买数量"
          ></el-input>
        </el-form-item>
        <el-form-item label="发票抬头：" label-width="100px">
          <el-input
            v-model="user_info.name"
            style="width:280px"
            autocomplete="off"
            placeholder="请输入发票抬头"
          ></el-input>
        </el-form-item>
        <el-form-item label="识别号：" label-width="100px">
          <el-input
            v-model="user_info.tax_number"
            style="width:280px"
            autocomplete="off"
            placeholder="请输入识别号"
          ></el-input>
        </el-form-item>
        <el-form-item label="收货地址：" label-width="100px">
          <el-input
            v-model="user_info.addresss"
            style="width:280px"
            autocomplete="off"
            placeholder="请输入收货地址"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" style="width:120px" :disabled="submit_btn" @click="submit">确 定</el-button>
        <el-button type="info" style="width:120px" @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import QrcodeVue from "qrcode.vue";
export default {
  components: {
    QrcodeVue
  },
  data() {
    return {
      submit_btn: false,
      error_show: false,
      dialogFormVisible: false,
      serve: this.$store.state.serve,
      id: this.$route.query.id,
      data: null,
      top4: [],
      user_info: {
        number: null,
        nickname: null,
        bind_mobile: null,
        name: null,
        tax_number: null,
        addresss: null,
        organization: null
      }
    };
  },
  created() {
    this.initData();
  },
  methods: {
    submit() {
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      const formData = new FormData();
      formData.append("mobile", this.$cookies.get("user"));
      formData.append("token", this.$cookies.get("token"));
      formData.append("group_id", this.data.info.id);
      if (this.user_info.bind_mobile != null) {
        formData.append("link_phone", this.user_info.bind_mobile);
      }
      if (this.user_info.nickname != null) {
        formData.append("buyer_name", this.user_info.nickname);
      }
      if (this.user_info.number != null) {
        formData.append("number", this.user_info.number);
      } else if (this.user_info.number === null) {
        return this.$message({
          type: "warning",
          message: "请输入购买数量，注意购买数量不能大于剩余数量"
        });
      }

      if (this.user_info.tax_number != null) {
        formData.append("duty_code", this.user_info.tax_number);
      }
      if (this.user_info.name != null) {
        formData.append("company_head", this.user_info.name);
      }
      if (this.user_info.addresss != null) {
        formData.append("address", this.user_info.addresss);
      }

      if (this.user_info.organization != null) {
        formData.append("company_name", this.user_info.organization);
      }
      this.axios
        .post(this.serve + "/group/GroupJoin", formData, config)
        .then(res => {
          if (res.data.status === "success") {
            this.dialogFormVisible = false;
            this.initData();
            this.$message({
              type: "success",
              message: "操作成功"
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    change_number_ipt(e) {
      if (e > this.data.info.surplus) {
        this.error_show = true;
        this.submit_btn = true;
      } else if (e <= this.data.info.surplus) {
        // this.buy_number = e
        this.error_show = false;
        this.submit_btn = false;
      }
    },
    ping() {
      this.axios
        .get(this.serve + "/isLogin", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          if (res.data.data == 1) {
            this.dialogFormVisible = true;
            this.get_info();
          } else {
            this.$router.push("/login");
          }
        });
    },
    get_info() {
      this.axios
        .get(this.serve + "/group/MemberInfo", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          if (res.data.status === "success") {
            this.user_info.nickname = res.data.data.nickname;
            this.user_info.bind_mobile = res.data.data.bind_mobile;
            if (res.data.data.invoice !== null) {
              this.user_info.name = res.data.data.invoice.name;
              this.user_info.tax_number = res.data.data.invoice.tax_number;
            }
            this.user_info.organization = res.data.data.organization;
            this.user_info.addresss =
              res.data.data.address.province +
              res.data.data.address.city +
              res.data.data.address.area +
              res.data.data.address.address;
          }
        });
    },
    onCopy() {
      this.success("链接已复制,快去分享吧！");
    },
    success(msg) {
      this.$message.success({
        type: "success",
        message: msg,
        offset: 150
      });
    },
    initData() {
      this.axios
        .get(this.serve + "/group/GroupInfo", {
          params: {
            id: this.id
          }
        })
        .then(res => {
          this.data = res.data.data;
        });
      this.loadTop4();
    },
    loadTop4() {
      this.top4 = [];
      this.axios
        .get(this.serve + "/group/randList", {
          params: {
            limit: 3
          }
        })
        .then(res => {
          this.top4 = res.data.data;
        });
    }
  }
  //   computed: {
  //     by_time() {
  //       return new Date(parseInt(this.data.results.buy_time) * 1000)
  //         .toLocaleString()
  //         .replace(/:\d{1,2}$/, " ")
  //         .slice(
  //           0,
  //           new Date(parseInt(this.data.results.buy_time) * 1000)
  //             .toLocaleString()
  //             .replace(/:\d{1,2}$/, " ")
  //             .indexOf(" ")
  //         );
  //     },
  //     ex_time() {
  //       return new Date(parseInt(this.data.results.create_date) * 1000)
  //         .toLocaleString()
  //         .replace(/:\d{1,2}$/, " ")
  //         .slice(
  //           0,
  //           new Date(parseInt(this.data.results.create_date) * 1000)
  //             .toLocaleString()
  //             .replace(/:\d{1,2}$/, " ")
  //             .indexOf(" ")
  //         );
  //     }
  //   }
};
</script>
<style lang="scss">
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
#viewIdle11 {
  width: 100%;
  border-top: 2px solid #e2211c;
  table {
    border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;
  }
  table td,
  table th {
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    padding: 3px 5px;
  }
  table th {
    border-bottom: 2px solid #ccc;
    text-align: center;
  }
  .viewIdle_box {
    width: 1200px;
    margin: 20px auto 0 auto;
    .box {
      background-color: #fff;
      padding: 40px 0 40px 40px;
      .b2 {
        span {
          color: #999999;
        }
        strong {
          font-weight: 400;
          color: #333;
        }
      }
    }
  }
  .d2:hover a {
    color: #e2211c;
  }
  .d2 {
    padding: 7px 0 10px 0;
  }
  .d3 {
    padding: 2px 0 10px 0;
  }
  .top4-item {
    background: #fff;
    margin-bottom: 20px;
  }
  .c1 {
    margin-bottom: 20px;
  }
  .name {
    line-height: 50px;
  }
  .d1 {
    width: 100%;
    display: flex;
    margin-top: 1px;
    .idleHome_right_seach_ipt {
      float: left;
      width: 520px;
      height: 40px;
      background: #f5f5f5;
      border-radius: 2px 0px 0px 2px;
      line-height: 40px;
      padding-left: 10px;
    }
  }
  .btn {
    margin-top: 22px;
    button {
      border-radius: 0;
      font-weight: bold;
      font-size: 18px;
    }
  }
  .avatar {
    border-radius: 50px;
    overflow: hidden;
  }
  .box2 {
    margin-top: 20px;
    .info {
      padding: 19px 42px;
      .info_top {
        font-size: 14px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        border-bottom: 1px solid #eeeeee;
      }

      .info_info h3 {
        text-align: center;
      }
    }
    .detale {
      width: 100%;
      height: 40px;
      background: rgba(238, 238, 238, 1);
      div {
        width: 108px;
        height: 38px;
        background: rgba(255, 255, 255, 1);
        font-size: 14px;
        font-weight: 500;
        text-align: center;
        line-height: 40px;
        border-top: 2px solid #e2211c;
        color: rgba(226, 33, 28, 1);
      }
    }
    .share_right {
      width: 100%;
      .share_right_tit {
        font-size: 14px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 40px;
        div {
          width: 68px;
          height: 1px;
          background: rgba(221, 221, 221, 1);
        }
        .share_right_list {
          width: 100%;
          height: 234px;
          background: orange;
        }
      }
    }
    .col {
      background-color: #fff;
      width: 100%;
    }
  }
  .t1 {
    font-size: 30px;
    margin-bottom: 19px;
    font-size: 24px;
    color: rgba(51, 51, 51, 1);
  }
  .b1 {
    font-size: 14px;
    height: 166px;
    background: rgba(221, 221, 221, 1);
    color: #333333;
    div {
      padding: 10px 0 10px 20px;
    }
  }
  .b2 {
    font-size: 14px;
    height: 196px;
    background: #f5f5f5;
    color: #333333;
    div {
      padding: 10px 0 10px 20px;
    }
  }
}
</style>

